import { IUserNotification } from '@tableau/user-notifications-client-core';

import { IGetItemsWithTokenParams } from '~src/ts/ServerApi/types/IGetItemsWithTokenParams';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';

export interface IGetUserNotificationsParams extends IGetItemsWithTokenParams {
}

export interface IGetUserNotificationsResult extends IGetItemsResult {
  userNotifications: IUserNotification<any>[];
}

export class GetUserNotificationsRequest extends Request<IGetUserNotificationsParams, IGetUserNotificationsResult> {
  constructor(params: IGetUserNotificationsParams = {}) {
    super('getUserNotifications', params);
  }
}